import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
export default function EnrollItemSkeleton() {
  return (
    <div className='p-4 border-b border-[#EAECF0] flex justify-between items-center'>
      <div className='flex gap-3 items-center w-full'>
        <Skeleton circle={true} height={40} width={40} className='rounded-full' />
        <Skeleton className='w-20 h-3' />
      </div>
      <Skeleton className='h-5 w-9 rounded-lg' />
    </div>
  );
}
